import { ExpensesFile, ExpensesFilesFormFragment } from 'generated/resources/graphql'

type FilesFormValues = {
  files: ExpensesFile[]
  filesIdToRemove: number[]
}

export const getFilesDefaultValues = (data?: ExpensesFilesFormFragment | null): FilesFormValues => {
  return {
    files: data?.expense?.files || data?.mileage?.files || data?.perDiem?.files || [],
    filesIdToRemove: [],
  }
}
